export default [
  {
    for: 'product',
    actions: {
      create: true,
      update: true,
      read: true,
      unlockEntity: true,
    },
  },
  {
    for: 'short-url',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
      unlockEntity: true,
      blockEntity: true,
    },
  },
];
